import { normalizePackageFeatures } from '../feature-library/collectPackageFeatures';

function uniqueAdminSlug(packages = []) {
  const used = new Set(
    packages.map((pkg) => String(pkg.slug || '').trim()).filter(Boolean)
  );
  if (!used.has('admin')) return 'admin';
  let index = 2;
  while (used.has(`admin_${index}`)) index += 1;
  return `admin_${index}`;
}

export function collectAllPackageFeatures(packages = []) {
  const seen = new Set();
  const features = [];

  packages.forEach((pkg) => {
    normalizePackageFeatures(pkg.features).forEach((feature) => {
      const key = feature.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      features.push(feature);
    });
  });

  return features;
}

export function buildUnlimitedAdminPackage(packages = []) {
  return {
    name: 'Admin',
    slug: uniqueAdminSlug(packages),
    description: 'Internal admin package with unlimited employees and every catalog feature.',
    price: {
      monthly: 0,
      annually: 0,
    },
    limits: {
      employees: -1,
    },
    features: collectAllPackageFeatures(packages),
    subscription: {
      gracePeriodDays: 0,
      autoRenew: false,
      trialDays: 0,
      billingOptions: [],
      annualDiscount: 0,
    },
    isActive: true,
    isAdminPackage: true,
    isTrialPackage: false,
  };
}
